import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { PAGE_NOT_FOUND_PATH,ADMIN_PATH} from '../../../utils/AppRoutes';
import AdminLayout from '.';
import CustomPageNotFound from '../../common/CustomPageNotFound';
import { ProtectedRoute } from '../../../utils/functions/CoreFunctions';

// Components
const AdminRouteControl = (props) =>{
    return ( 
        <Switch>            
            <ProtectedRoute path={ADMIN_PATH} component={AdminLayout} />           
            <Route path={PAGE_NOT_FOUND_PATH} component={CustomPageNotFound} /> 
        </Switch>
    );
}

export default AdminRouteControl;